<template>
  <div class="error-message">
    <span>{{text}}</span>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'error-message',
  props: {
    text: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang="less" scoped>
  .error-message {
    margin: 1.2rem auto;
    span {
      color: #9e9e9e;
    }
  }
</style>
